import { getDownloadURL, getMetadata, listAll } from "firebase/storage";
import { getFileName } from "./getFileName";

const getUrlAndMeta = async (item) => {
  const url = await getDownloadURL(item);
  const data = await getMetadata(item);
  return{ data, url};
};


export async function getAllImages(imageListRef) {
  const listAlls = await listAll(imageListRef);
  let imageArr = [];

for (const item of listAlls.items) {
    const {url, data} = await getUrlAndMeta(item);
    let addImg = true;
    imageArr.forEach((img) => {
      if (img?.fullPath === item?.fullPath) {
        addImg = false;
        return;
      }
    });
    if (addImg) {
      const obj = {
        name: item.name,
        originalName: getFileName(item.name),
        fullPath: item.fullPath,
        parent: item.parent.name,
        root: item.root.name,
        link: url,
        size: data.size,
        created: data.timeCreated,
        updated: data.updated,
        contentType: data.contentType,
        item: item,
      };
      //console.log(obj);
      imageArr.push(obj);
    }
    
  }  
return imageArr;
}

